import React from 'react';

import LongForm from '$components/long-form';
import { nestBrowserMedia } from './utils';

export function Text(props: { children: React.ReactNode }) {
  const { children } = props;

  return <LongForm>{nestBrowserMedia(children)}</LongForm>;
}
